import { API_CASINO_REPORT_BONUS_SUMMARY } from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import BonusSummaryResponse from '../Responses/BonusSummaryResponse';

class CasinoBonusesApi extends AbstractCasinoCRMApi {
    public async getBonusSummary(bonusId: number, bonusType: string): Promise<BonusSummaryResponse> {
        return (
            await this.get(API_CASINO_REPORT_BONUS_SUMMARY, {
                params: {
                    bonusId,
                    bonusType,
                },
            })
        ).data;
    }
}

export default new CasinoBonusesApi();
